var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_wrapper"},[_c('default-form',{attrs:{"block_data":_vm.block_data,"custom_fields":_vm.custom_fields,"is_mobile_resolution":_vm.ui.is_mobile_resolution,"type":'sponsorship'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }